import { Injectable } from '@angular/core';
import { LicenceDataModel } from 'src/app/models/lic-list.model';
import { SessionStorageModel } from 'src/app/models/session-storage';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  sessionDataChanges: BehaviorSubject<SessionStorageModel | null> = new BehaviorSubject<SessionStorageModel | null>(this.readSessionData());

  constructor() { }
  /**
   * Set Storage Data
   * @param data
   */
  setSessionData(data: SessionStorageModel) {
    if (!data || typeof data !== 'object') {
      localStorage.removeItem('_UserDetails');
      this.sessionDataChanges.next(null);
      return;
    }
    localStorage.setItem('_UserDetails',JSON.stringify(data));
    this.sessionDataChanges.next(data);
  }

  getSessionData() {
    return this.readSessionData();
  }

  private readSessionData(): SessionStorageModel | null {
    let  sessionData: any =  localStorage.getItem('_UserDetails');
    if (sessionData) {
      try {
        let data: SessionStorageModel = JSON.parse(sessionData);
        return data;
      } catch (error) {
        localStorage.removeItem('_UserDetails');
        return null;
      }
    }
    return null;
  }

  getRefreshAccessToken() {
    let data: any = this.getSessionData();
    if (data) {
      return data.refresh_token;
    }
    return "";
  }

  clearAllSession() {
    let isAcceptedTerm = this.getPolicyAccepted();
    localStorage.clear();
    localStorage.setItem("isPolicyUpdated", JSON.stringify(isAcceptedTerm));
    if (!localStorage.getItem("isShowPromo")) {
      localStorage.setItem("isShowPromo", "true");
      localStorage.setItem("StartTime", "startTimer");
      sessionStorage.removeItem("showSubscription");
    }
    this.sessionDataChanges.next(null);
  }

  /**
 * Update I understand Click
 */
  updateUnderStandClickValue() {
    localStorage.setItem('isClickUnderStand', "true");
  }

  setBeatViewType(viewType: string) {
    localStorage.setItem('viewType', viewType);
  }

  getViewType() {
    return localStorage.getItem('viewType');
  }

  /**
   * get Current User Role
   * @returns
   */
  getCurrentRoles() {
    let data: any = this.getSessionData();
    if (data) {
      return data.role;
    }
    return '';
  }

  getUserId(): string {
    let data: any = this.getSessionData();
    if (data ) {
      return data.userId;
    }
    return '';
  }

  updateCurrentRole(currentRole: string) {
    let data: any = this.getSessionData();
    if (!data) {
      return;
    }
    data.role = currentRole;
    this.setSessionData(data);
  }


  /**
   * get I understand Click value
   */
  getUnderStandClickValue() {
    let  isClickUnderStand = localStorage.getItem("isClickUnderStand");
    return isClickUnderStand;
  }

  /**
   * set Licence Data into session
   * @licData: object
   */
  setLicData(liceData: any) {
    sessionStorage.setItem("liceData", JSON.stringify(liceData));
  }

  /**
   * set Licence Data into session
   */
  getLicData() :  Array<LicenceDataModel> {
    let licData: any =  sessionStorage.getItem("liceData");
    if (licData) {
      let licList: Array<any> = JSON.parse(licData);
      let  index: any = licList.findIndex(item => item.title === "Negotiated Exclusive");
      if (index > -1) {
        licList.splice(index, 1)
      }
      return licList;
    }
    return [];
  }

    errorHandler(event: any, type: string = '') {
      let imageName = 'icons/music-Icon.svg';
      if (type ) {
        imageName = type === 'userIcon' ? 'icons/user-icon.svg' : 'icons/profile-image.svg';
      }
      event.target.src = environment.imageUrl+imageName;
    }

    getSellerRedirectDashBoard() {
      let data: any = this.getSessionData();
      if (data) {
        return data.isSellerRedirectDashBoard;
      }
      return false;
    }

    setSellerRedirectDashBoard() {
      let data: any = this.getSessionData();
      if (data) {
        data.isSellerRedirectDashBoard = true;
      }
      this.setSessionData(data);
    }


    setPlayCountNonLoginUser(count: any) {
      let encryptedData = this.set(JSON.stringify(count));
      localStorage.setItem('playCount', encryptedData);
    }

    getPlayCount() {
      let data:any = localStorage.getItem('playCount');
      let decryptedUserData = '';
      if (data !== undefined && data !== null && data !== '') {
        decryptedUserData = this.get(data);
      }
      return +decryptedUserData;
    }

    deletePlayCount() {
      localStorage.removeItem('playCount');
    }

    setListeningDashboardPromoSeen() {
      localStorage.setItem('listeningDashboardPromoSeen', 'true');
    }

    //This is a testing purpose function to reset the value.
    resetListeningDashboardPromoSeen(){
      localStorage.setItem('listeningDashboardPromoSeen', '');
    }

    hasSeenListeningDashboardPromo() {
      return localStorage.getItem('listeningDashboardPromoSeen') === 'true';
    }

  setAdsPopupSeenTime() {
    localStorage.setItem('adsPopupSeenAt', Date.now().toString());
  }

  getAdsPopupSeenTime() {
    const value = localStorage.getItem('adsPopupSeenAt');
    return value ? Number(value) : null;
  }


    set(value:any){
      let keys  = "123456$#@$^@1ERF";
      var key = CryptoJS.enc.Utf8.parse(keys);
      var iv = CryptoJS.enc.Utf8.parse(keys);
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });

      return encrypted.toString();
    }

    //The get method is use for decrypt the value.
    get(value:any){
      let keys  = "123456$#@$^@1ERF";
      var key = CryptoJS.enc.Utf8.parse(keys);
      var iv = CryptoJS.enc.Utf8.parse(keys);
      var decrypted = CryptoJS.AES.decrypt(value, key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    }

    /**
 * Set previous route before redirecting to auth
 * @param route - the route to redirect back to after login
 */
setPreviousRoute(route: string) {
  let data: any = {};
  data.previousRoute = route;
  data.returnUrl = route;
  localStorage.setItem("previousRouteDetails", JSON.stringify(data));
}

  /**
   * Get previous route to redirect to after login
   * @returns previous route or null
   */
  getPreviousRoute(): string | null {
    let data: any = localStorage.getItem("previousRouteDetails");
    let previousRouteDetails: any = data ? JSON.parse(data) : "";
    if (previousRouteDetails && previousRouteDetails.previousRoute) {
      return previousRouteDetails.previousRoute;
    }
    return null;
  }

    /**
   * Get return URL (alias for getPreviousRoute for consistency)
   */
  getReturnUrl(): string | null {
    return this.getPreviousRoute();
  }

  /**
   * Clear previous route after successful redirect
   */
  clearPreviousRoute() {
    localStorage.removeItem("previousRouteDetails");
  }

  /**
   * Check if the route is a base route that should redirect to dashboard
   * @param route - route to check
   * @returns boolean
   */
  isBaseRoute(route: string): boolean {
    const baseRoutes = ['/', '', '/signin', '/signup', '/error'];
    return baseRoutes.includes(route);
  }

  /**
   * Get appropriate dashboard route based on user role
   * @param userRole - user role (producer, customer, etc.)
   * @returns dashboard route
   */
  getDashboardRoute(userRole: string): string {
    switch (userRole) {
      case 'producer':
        return '/dashboard/keyPerformanceIndicators'; 
      default:
        return '/listening-dashboard'; // Buyers land on Listening dashboard
    }
  }

    /**
   * Redirect to route with full page reload
   * @param route - route to redirect to
   */
    redirectWithReload(route: string) {
      this.clearPreviousRoute();
      window.location.href = route;
    }

    setDataEnrolBpmDialog(isShowBpmDailog: any) {
      localStorage.setItem("isShowBpmPopup", isShowBpmDailog);
    }

    setDataEnrolDisenrolledBpmDialog(isShowBpmDailog: any) {
      localStorage.setItem("isShowBpmDisenrollPopup", isShowBpmDailog);
    }
    getDataEnrolDisenrolledBpmDialog(): boolean {
      let isShowBpmValue = localStorage.getItem("isShowBpmDisenrollPopup");
      if (isShowBpmValue === "true") {
        return true;
      }
      return false;
    }

    getValueEnrolBpmDialogValue(): boolean {
      let isShowBpmValue = localStorage.getItem("isShowBpmPopup");
      if (isShowBpmValue === "true") {
        return true;
      }
      return false;
    }

    removedBpmDialogValue() {
      localStorage.removeItem("isShowBpmPopup")
    }

    /**
     * Sale enrol popup (producers with no enrolled beats): shown again only after `days` days.
     * Tracked per user and per sale, so a new sale shows the popup again.
     */
    private bpmSalePopupKey(userId: string, saleId: string): string {
      return `bpmSalePopupShownAt:${userId}:${saleId}`;
    }

    setBpmSalePopupShownAt(userId: string, saleId: string): void {
      localStorage.setItem(this.bpmSalePopupKey(userId, saleId), String(Date.now()));
    }

    canShowBpmSalePopup(userId: string, saleId: string, days: number = 2): boolean {
      const shownAt = Number(localStorage.getItem(this.bpmSalePopupKey(userId, saleId)));
      return !shownAt || Date.now() - shownAt >= days * 24 * 60 * 60 * 1000;
    }

    /** Active platform sale is running (start_at - end_at), see CommonService.isSaleActive */
    setSaleActiveFlag(isSaleActive: boolean) {
      localStorage.setItem("isSaleActive", JSON.stringify(isSaleActive));
    }

    getSaleActiveFlag(): boolean {
      let isSaleActive = localStorage.getItem("isSaleActive");
      if (isSaleActive) {
        return JSON.parse(isSaleActive);
      }
      return false;
    }

    /** Enrollment open for the active platform sale, see CommonService.isEnrollmentActive */
    setEnrollmentActiveFlag(isEnrollmentActive: boolean) {
      localStorage.setItem("isEnrollmentActive", JSON.stringify(isEnrollmentActive));
    }

    getEnrollmentActiveFlag(): boolean {
      const isEnrollmentActive = localStorage.getItem("isEnrollmentActive");
      return isEnrollmentActive ? JSON.parse(isEnrollmentActive) : false;
    }

    setCurrentSaleStatus(status: 'upcoming' | 'live' | 'ended') {
      localStorage.setItem("currentSaleStatus", status);
    }

    getCurrentSaleStatus(): 'upcoming' | 'live' | 'ended' | null {
      let status = localStorage.getItem("currentSaleStatus");
      if (status === 'upcoming' || status === 'live' || status === 'ended') {
        return status;
      }
      return null;
    }


    setPolicyAccepted() {
       localStorage.setItem("isPolicyUpdated", "true");
    }

    getPolicyAccepted() {
      let isPolicyUpdated = localStorage.getItem("isPolicyUpdated");
      if (isPolicyUpdated) {
        return JSON.parse(isPolicyUpdated);
      }
      return false;
    }

    /**
     * Marks that this user has already seen the ad popup once.
     * Key is per-user so each account gets exactly one view.
     * Falls back to a guest key for non-logged-in users.
     * @param userId - the logged-in user's _id, or 'guest'
     */
    markAdPopupSeen(userId: string): void {
      const key = `ipm_ad_popup_seen_${userId || 'guest'}`;
      localStorage.setItem(key, 'true');
    }

    /**
     * Returns true if this user has already seen the ad popup.
     * @param userId - the logged-in user's _id, or 'guest'
     */
    hasAdPopupBeenSeen(userId: string): boolean {
      const key = `ipm_ad_popup_seen_${userId || 'guest'}`;
      return localStorage.getItem(key) === 'true';
    }

    /**
     * Marks that the MP3 license bulk-enable action has been run for this user.
     * Key is per-user so switching accounts doesn't bleed state.
     * @param userId - the logged-in user's _id
     */
    setMp3LicenseEnabled(userId: string): void {
      const key = `mp3_license_enabled_${userId || 'unknown'}`;
      localStorage.setItem(key, 'true');
    }

    /**
     * Returns true if the MP3 license bulk-enable action has already been run for this user.
     * @param userId - the logged-in user's _id
     */
    isMp3LicenseEnabled(userId: string): boolean {
      const key = `mp3_license_enabled_${userId || 'unknown'}`;
      return localStorage.getItem(key) === 'true';
    }

    /**
     * Marks that this user has already seen the MP3 license intro popup once.
     * Kept separate from is_mp3_enabled since that flag is also driven by Studio Controls.
     * @param userId - the logged-in user's _id
     */
    markMp3LicenseIntroSeen(userId: string): void {
      const key = `mp3_license_intro_seen_${userId || 'unknown'}`;
      localStorage.setItem(key, 'true');
    }

    /**
     * Returns true if this user has already seen the MP3 license intro popup.
     * @param userId - the logged-in user's _id
     */
    hasMp3LicenseIntroBeenSeen(userId: string): boolean {
      const key = `mp3_license_intro_seen_${userId || 'unknown'}`;
      return localStorage.getItem(key) === 'true';
    }
}
